import classNames from 'classnames';
import React from 'react';

import { Space, Typography } from '@sravni/react-design-system';

import { render } from '../../../utils/markdown';
import styles from '../comments-list.module.scss';

import { ICommentCardProps } from './Card';

interface IProps extends Pick<ICommentCardProps, 'item' | 'isBankAnswer'> {
  isLoggedIn: boolean;
  handleShowCommentForm: () => void;
  handleEditClick: () => void;
}

export const CardBody: React.FC<IProps> = ({
  item,
  isLoggedIn,
  isBankAnswer,
  handleShowCommentForm,
  handleEditClick,
}) => {
  const text = render(item.text);

  return (
    <Space direction={'vertical'}>
      <Space className={'h-mb-8'}>
        <Typography.Text size={16} className={styles.cardText} dangerouslySetInnerHTML={{ __html: text }} />
      </Space>
      <Space>
        {!isBankAnswer && isLoggedIn && (
          <Typography.Text
            as={'button'}
            size={14}
            className={classNames(styles.interactButton, 'h-color-D60 h-mr-12')}
            onClick={handleShowCommentForm}
          >
            Ответить
          </Typography.Text>
        )}
        {item.canEdit && (
          <Typography.Text as={'a'} size={14} className={'h-color-D60'} onClick={handleEditClick}>
            Редактировать
          </Typography.Text>
        )}
      </Space>
    </Space>
  );
};
